<template>
	<div class="client-area-booking">
		<div class="client-area-booking__event">
			<event-header :event="event"/>
		</div>

		<div class="client-area-booking__table-wrapper">
			<table class="client-bookings">
				<thead>
					<tr>
						<th>{{translation.id}}</th>
						<th>{{translation.date}}</th>
						<th>{{translation.client}}</th>
						<th>{{translation.description}}</th>
						<th>{{translation.status}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(file, index) in handleFiles" :key="index">
						<td :data-label="translation.id">{{file.fileNumber}}</td>
						<td :data-label="translation.date">{{handleDate(file.creationDate)}}</td>
						<td :data-label="translation.client">{{file.pax}}</td>
						<td :data-label="translation.description">{{handleDescription(file)}}</td>
						<td :data-label="translation.status">{{file.status.name}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import { translate } from '../../assets/translations';
import EventHeader from '../event/EventHeader.vue';
import Status from '../../enums/Status';
import { formatDate } from '../../assets/format';

export default {
	components: {
		EventHeader
	},
	props:['files'],
	data() {
		return {
			event: this.$store.state.event
		}
	},
	computed:{
		translation() {
			return translate(this.$store.state.language).clientTable;
		},
		handleFiles() {
			let filteredFiles = this.files.filter(file => file.status.code !== Status.PD.code);
			return filteredFiles;
		},
	},
	methods: {
		handleDescription(file) {
			let descriptions = file.bookings.map(booking => booking.description);
			descriptions = descriptions.filter(description => description !== null && description !== '');
			return descriptions.length > 0? descriptions.join(' / ') : this.translation.informationUnavailable;
		},
		handleDate(date){
			return formatDate(date, "DD/MM/YYYY");

		},
	},
}
</script>
<style scoped lang="scss">
.client-area-booking {
	width: 100%;
}

.client-area-booking__event {
	box-sizing: border-box;
	margin-bottom: 28px;
	padding: 28px 32px;
	border-radius: 20px;
	background: #eeeeee;
}

.client-area-booking__event /deep/ .event-header {
	color: #5a5a5a;
}

.client-area-booking__event /deep/ .title {
	margin: 0 0 8px;
	color: #002c41;
	font-size: 18px;
	line-height: 23px;
}

.client-area-booking__event /deep/ .period-location {
	margin: 0 0 8px;
	font-size: 15px;
	line-height: 21px;
}

.client-area-booking__event /deep/ .email {
	color: #5da3bd;
}

.client-area-booking__table-wrapper {
	width: 100%;
	overflow-x: auto;
	border-radius: 20px;
	background: #ffffff;
	box-shadow: 0 5px 18px rgba(0, 44, 65, .08);
}

.client-bookings {
	width: 100%;
	min-width: 760px;
	border-collapse: collapse;
	color: #5a5a5a;
}

.client-bookings th,
.client-bookings td {
	padding: 18px 20px;
	text-align: left;
}

.client-bookings th {
	background: #11344a;
	color: #ffffff;
	font-size: 14px;
	font-weight: 700;
	line-height: 18px;
}

.client-bookings th:first-child {
	border-radius: 20px 0 0;
}

.client-bookings th:last-child {
	border-radius: 0 20px 0 0;
}

.client-bookings td {
	border-bottom: 1px solid #dedede;
	background: #ffffff;
	font-size: 14px;
	line-height: 20px;
}

.client-bookings tbody tr:last-child td {
	border-bottom: 0;
}

.client-bookings tbody tr:hover td {
	background: #edf6f9;
}

@media (max-width: 600px) {
	.client-area-booking__event {
		padding: 24px 20px;
	}

	.client-area-booking__table-wrapper {
		overflow: visible;
		border-radius: 0;
		background: transparent;
		box-shadow: none;
	}

	.client-bookings {
		display: block;
		min-width: 0;
	}

	.client-bookings thead {
		display: none;
	}

	.client-bookings tbody {
		display: grid;
		gap: 16px;
	}

	.client-bookings tbody tr {
		display: block;
		overflow: hidden;
		border: 1px solid #dedede;
		border-radius: 14px;
		background: #ffffff;
		box-shadow: 0 4px 14px rgba(0, 44, 65, .06);
	}

	.client-bookings td,
	.client-bookings tbody tr:last-child td {
		display: grid;
		grid-template-columns: 110px minmax(0, 1fr);
		gap: 12px;
		box-sizing: border-box;
		width: 100%;
		padding: 14px 16px;
		border-bottom: 1px solid #dedede;
		word-break: break-word;
	}

	.client-bookings td:last-child,
	.client-bookings tbody tr:last-child td:last-child {
		border-bottom: 0;
	}

	.client-bookings td::before {
		content: attr(data-label);
		color: #002c41;
		font-weight: 700;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/clients-area/ClientsAreaBookings.vue